export const trimSlash = str => str.replace(/^\/+|\/+$/g, "")
